import TYPES from '@/types';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class EditUserProfilePersonalityDialogViewModel {
  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  readonly i18n_namespace = 'components.user-profile.user-profile-tabs.edit-user-profile-personality.main-dialog';

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  readonly STEPS = [
    {
      component: 'FlagshipProfilingStepEconomicDependents',
      name: 'economic_dependents',
    },
    {
      component: 'FlagshipProfilingStepEmploymentSituation',
      name: 'employment_situation',
    },
    {
      component: 'FlagshipProfilingStepEmploymentSituation',
      name: 'education_level',
    },
    {
      component: 'FlagshipProfilingStepFinancialHabits',
      name: 'monthly_savings_capacity',
    },
    {
      component: 'EditUserProfilePersonalityInvestmentExperience',
      name: 'investment_experience',
    },
  ];

  is_loading = false;

  current_step = 0;

  current_component = this.STEPS[this.current_step];

  show_employee_situation = false;

  show_study_level = false;

  is_editing_personality_profile = true;

  setLoadingState = (is_loading: boolean) => {
    this.is_loading = is_loading;
  }

  initialize = async (component_to_edit: string) => {
    this.current_step = this.STEPS.findIndex((value) => value.name === component_to_edit);
    if (this.current_step) {
      if (component_to_edit === 'employment_situation') this.show_employee_situation = true;
      if (component_to_edit === 'education_level') this.show_study_level = true;
      this.current_component = this.STEPS[this.current_step];
    }
  }
}
